import { render, staticRenderFns } from "./details.vue?vue&type=template&id=b15aa694&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=b15aa694&prod&lang=scss&scoped=true&"
import style1 from "./details.vue?vue&type=style&index=1&id=b15aa694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15aa694",
  null
  
)

export default component.exports